import script from "./blfhsj.vue?vue&type=script&setup=true&lang=js"
export * from "./blfhsj.vue?vue&type=script&setup=true&lang=js"

import "./blfhsj.vue?vue&type=style&index=0&id=7f95a618&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f95a618"]])

export default __exports__